var thermalPrint = require('./thermal-print.cjs.js');
var createDocument = thermalPrint.createDocument;

var COLS = 32;

function pad(left, right) {
    var l = String(left);
    var r = String(right);
    var espacio = COLS - l.length - r.length;
    if (espacio < 1) espacio = 1;
    return l + " ".repeat(espacio) + r;
}

function centrar(txt) {
    var t = String(txt);
    if (t.length >= COLS) return t;
    var esp = Math.floor((COLS - t.length) / 2);
    return " ".repeat(esp) + t;
}

function sep() {
    return "-".repeat(COLS);
}

function fmt(value) {
    var num = Number(value) || 0;
    return "Q " + num.toFixed(2);
}

function fmtFecha(iso) {
    if (!iso) return "";
    try {
        var d = new Date(iso);
        var dd = String(d.getDate()).padStart(2, "0");
        var mm = String(d.getMonth() + 1).padStart(2, "0");
        var yyyy = d.getFullYear();
        var hh = String(d.getHours()).padStart(2, "0");
        var mi = String(d.getMinutes()).padStart(2, "0");
        return dd + "/" + mm + "/" + yyyy + " " + hh + ":" + mi;
    } catch (_) {
        return String(iso);
    }
}

// Partir texto largo en lineas de COLS caracteres
function partir(txt) {
    var t = String(txt);
    var lineas = [];
    while (t.length > 0) {
        lineas.push(t.substring(0, COLS));
        t = t.substring(COLS);
    }
    return lineas;
}


export function createReciboCajaDoc(opts) {
    var movimiento = opts.movimiento;
    var sucursal = opts.sucursal || (movimiento && movimiento.sucursal) || {};

    var datosEmpresa = sucursal.datos_empresa || {};
    var cliente = movimiento.cliente_proveedor || movimiento.cliente || {};
    var detalles = movimiento.detalles || [];
    var usuario = movimiento.usuario || {};
    var cuentaCobrar = movimiento.cuenta_cobrarpagar || {};
    var datosFel = movimiento.datos_fel;

    var doc = createDocument();

    // Encabezado
    doc.text(centrar(datosEmpresa.nombre_comercial || sucursal.nombre || " "));
    doc.text(centrar(sucursal.nombre || " "));
    if (sucursal.direccion) {
        var lineasDir = partir(sucursal.direccion);
        for (var di = 0; di < lineasDir.length; di++) {
            doc.text(centrar(lineasDir[di]));
        }
    }
    if (sucursal.telefono) {
        doc.text(centrar("Tel. " + String(sucursal.telefono)));
    }

    doc.text(sep());
    doc.text(centrar("RECIBO DE CAJA"));
    doc.text(sep());

    doc.text(pad("Codigo de venta:", movimiento.codigo_venta || " "));
    doc.text(pad("Fecha y hora:", fmtFecha(movimiento.creado)));
    if (usuario.first_name) {
        doc.text(pad("Usuario:", usuario.first_name));
    }

    doc.text(sep());
    doc.text(pad("Nombre:", cliente.nombre || "CONSUMIDOR FINAL"));
    doc.text(pad("NIT:", cliente.nit || "CF"));
    if (cuentaCobrar.fecha_vencimiento) {
        doc.text(pad("F. vencimiento:", fmtFecha(cuentaCobrar.fecha_vencimiento)));
    }

    // Artículos
    if (detalles.length > 0) {
        doc.text(sep());
        doc.text(pad("ARTICULOS", "SUB TOTAL"));
        doc.text(sep());
        for (var i = 0; i < detalles.length; i++) {
            var d = detalles[i];
            var cant = d.cantidad || 1;
            var precioOrig = d.precio_original || d.precio || 0;
            var subtotal = d.sub_total || d.subtotal || (cant * precioOrig);
            var nombre = (typeof d.producto === "string") ? d.producto : (d.producto && d.producto.nombre) || d.nombre || " ";
            var fraccion = (d.fraccion && d.fraccion.nombre) ? d.fraccion.nombre : "";
            var descLinea = String(nombre);
            if (fraccion) descLinea += " / " + fraccion;
            doc.text(String(descLinea));
            doc.text(pad(fmt(precioOrig) + " X " + String(cant), fmt(subtotal)));
            if (d.precio_original && d.desc_porcentaje > 0) {
                doc.text("  Descuento (" + d.desc_porcentaje + "%)");
                doc.text(pad("  -" + fmt(d.desc_monto) + " X " + String(cant), "-" + fmt(cant * d.desc_monto)));
            }
        }
    }

    doc.text(sep());

    // Total de venta (el original, no el monto pagado)
    var totalVenta = Number(movimiento.total_orginal) || Number(movimiento.total_cobrar_pagar) || Number(movimiento.total) || 0;
    doc.text(pad("TOTAL DE VENTA", fmt(totalVenta)));

    // Anticipos (lo que se pagó al momento de la venta)
    var efectivo = Number(movimiento.monto_efectivo) || 0;
    var tarjeta = Number(movimiento.monto_tarjeta) || 0;
    var cheque = Number(movimiento.monto_cheque) || 0;
    var deposito = Number(movimiento.monto_deposito) || 0;


    doc.text(pad("ANTICIPO EN EFECTIVO", fmt(efectivo)));
    doc.text(pad("ANTICIPO EN TARJETA", fmt(tarjeta)));
    doc.text(pad("ANTICIPO EN CHEQUE", fmt(cheque)));
    doc.text(pad("ANTICIPO EN DEPOSITO", fmt(deposito)));

    doc.text(sep());

    // Saldo al crédito
    var totalAnticipo = efectivo + tarjeta + cheque + deposito;
    var saldo = totalVenta - totalAnticipo;
    doc.text(pad("SALDO AL CREDITO", fmt(saldo)));

    // ---- NUEVO: Abonos y saldo final ----
    var cuentaCobrar = movimiento.cuenta_cobrarpagar || {};
    var abonos = cuentaCobrar.abonos || [];
    if (abonos.length > 0) {
        doc.text(sep());
        doc.text("ABONOS:");
        for (var a = 0; a < abonos.length; a++) {
            var abono = abonos[a];
            var fechaAbono = fmtFecha(abono.creado);
            // Solo fecha corta (sin hora)
            if (fechaAbono.indexOf(" ") > -1) {
                fechaAbono = fechaAbono.split(" ")[0];
            }
            var montoAbono = Number(abono.total) || 0;
            doc.text(pad(fechaAbono, fmt(montoAbono)));
        }
        doc.text(sep());
        var saldoFinal = Number(cuentaCobrar.saldo);
        if (isNaN(saldoFinal)) {
            // Calcular si no viene directo
            var totalAbonos = 0;
            for (var b = 0; b < abonos.length; b++) {
                totalAbonos += Number(abonos[b].total) || 0;
            }
            saldoFinal = saldo - totalAbonos;
        }
        doc.text(pad("SALDO", fmt(saldoFinal)));
    }

    // FEL o no factura
    if (datosFel && datosFel.uuid) {
        doc.text(sep());
        if (datosFel.frase_fel) doc.text(centrar(String(datosFel.frase_fel)));
        if (datosFel.serie) doc.text(pad("Serie:", datosFel.serie));
        if (datosFel.numero) doc.text(pad("Numero:", datosFel.numero));
        doc.text(centrar("AUTORIZACION FEL"));
        doc.text(String(datosFel.uuid));
        if (datosFel.fechaCertificacion) {
            doc.text(centrar("FECHA CERTIFICACION"));
            doc.text(centrar(fmtFecha(datosFel.fechaCertificacion)));
        }
        if (datosFel.datos_generados) {
            var datos = datosFel.datos_generados;
            if (typeof datos === "string") {
                try {
                    datos = JSON.parse(datos.replace(/'/g, '"').replace(/None/g, 'null').replace(/True/g, 'true').replace(/False/g, 'false'));
                } catch(e) { datos = null; }
            }
            if (datos && datos.nit_certificador) {
                doc.text(centrar("CERTIFICADOR"));
                doc.text(centrar("NIT: " + datos.nit_certificador));
                doc.text(centrar(datos.nombre_certificador || ""));
            }
        }
    } else {
        doc.text(sep());
        doc.text(centrar("ESTE DOCUMENTO"));
        doc.text(centrar("NO ES UNA FACTURA"));
    }

    doc.text(" ");
    doc.cut();
    return doc;


}

export function buildReciboCaja(opts) {
    return createReciboCajaDoc(opts).build();
}

export function createReciboDoc(opts) {
    var movimiento = opts.movimiento;
    var sucursal = opts.sucursal || (movimiento && movimiento.sucursal) || {};
    var utiliza_fel = opts.utiliza_fel;
    var conf_tipo_negocio = opts.conf_tipo_negocio;

    var datosEmpresa = sucursal.datos_empresa || {};
    var cliente = movimiento.cliente_proveedor || movimiento.cliente || {};
    var detalles = movimiento.detalles || movimiento.detalle_movimiento || [];
    var usuario = movimiento.usuario || {};
    var datosFel = movimiento.datos_fel;

    var doc = createDocument();

    // Encabezado
    doc.text(centrar(datosEmpresa.nombre_comercial || sucursal.nombre || " "));
    doc.text(centrar(sucursal.nombre || " "));
    if (sucursal.direccion) {
        var lineasDir = partir(sucursal.direccion);
        for (var di = 0; di < lineasDir.length; di++) {
            doc.text(centrar(lineasDir[di]));
        }
    }
    if (sucursal.telefono) {
        doc.text(centrar("Tel. " + String(sucursal.telefono)));
    }

    doc.text(sep());

    // Codigo y fecha
    doc.text(pad("Codigo:", movimiento.codigo_venta || movimiento.codigo || movimiento.id || " "));
    doc.text(pad("Fecha:", fmtFecha(movimiento.creado || movimiento.fecha)));

    doc.text(sep());

    // Cliente
    doc.text(pad("Nombre:", cliente.nombre || "CONSUMIDOR FINAL"));
    doc.text(pad("NIT:", cliente.nit || "CF"));
    if (cliente.direccion) {
        doc.text(pad("Direccion:", cliente.direccion));
    }
    if (usuario.first_name) {
        doc.text(pad("Usuario:", usuario.first_name));
    }

    doc.text(sep());
    doc.text(pad("ARTICULOS", "SUB TOTAL"));
    doc.text(sep());

    // Detalle productos
    for (var i = 0; i < detalles.length; i++) {
        var d = detalles[i];
        var cant = d.cantidad || 1;
        var precioOrig = d.precio_original || d.precio || 0;
        var subtotal = d.sub_total || d.subtotal || (cant * precioOrig);

        var nombre = (typeof d.producto === "string") ? d.producto : (d.producto && d.producto.nombre) || d.nombre || " ";
        var fraccion = (d.fraccion && d.fraccion.nombre) ? d.fraccion.nombre : "";

        var descLinea = String(nombre);
        if (fraccion) descLinea += " / " + fraccion;

        doc.text(String(descLinea));
        doc.text(pad(fmt(precioOrig) + " X " + String(cant), fmt(subtotal)));

        if (d.precio_original && d.desc_porcentaje > 0) {
            doc.text("  Descuento (" + d.desc_porcentaje + "%)");
            doc.text(pad("  -" + fmt(d.desc_monto) + " X " + String(cant), "-" + fmt(cant * d.desc_monto)));
        }
    }

    doc.text(sep());

    // Crédito por devolución
    var creditoDev = Number(movimiento.monto_credito_devolucion) || 0;
    if (creditoDev > 0) {
        doc.text(pad("Credito devolucion", "-" + fmt(creditoDev)));
    }

    // Totales
    doc.text(pad("TOTAL", fmt(movimiento.total || 0)));
    doc.text(pad("PAGO RECIBIDO", fmt(movimiento.pago_recibido || movimiento.total || 0)));

    if (movimiento.vuelto_efectivo && Number(movimiento.vuelto_efectivo) !== 0) {
        doc.text(pad("VUELTO", fmt(movimiento.vuelto_efectivo)));
    }

    doc.text(sep());

    // FEL o no factura
    if (datosFel && datosFel.uuid) {
        if (datosFel.frase_fel) doc.text(centrar(String(datosFel.frase_fel)));
        if (datosFel.serie) doc.text(pad("Serie:", datosFel.serie));
        if (datosFel.numero) doc.text(pad("Numero:", datosFel.numero));
        doc.text(centrar("AUTORIZACION FEL"));
        doc.text(String(datosFel.uuid));
        if (datosFel.fechaCertificacion) {
            doc.text(centrar("FECHA CERTIFICACION"));
            doc.text(centrar(fmtFecha(datosFel.fechaCertificacion)));
        }
        if (datosFel.datos_generados) {
            let datos = datosFel.datos_generados;
            if (typeof datos === "string") {
                try {
                    datos = JSON.parse(datos.replace(/'/g, '"').replace(/None/g, 'null').replace(/True/g, 'true').replace(/False/g, 'false'));
                } catch(e) { datos = null; }
            }
            if (datos && datos.nit_certificador) {
                doc.text(centrar("CERTIFICADOR"));
                doc.text(centrar("NIT: " + datos.nit_certificador));
                doc.text(centrar(datos.nombre_certificador || ""));
            }
        }
    } else {
        doc.text(centrar("ESTE DOCUMENTO"));
        doc.text(centrar("NO ES UNA FACTURA"));
    }

    doc.text(" ");
    doc.cut();

    return doc;
}


/**
 * Builder para imprimir Nota de Crédito (NCRE) en impresora térmica.
 */
function createReciboNCREDoc(opts) {
    var movimiento = opts.movimiento;
    var sucursal = opts.sucursal || {};
    var datosEmpresa = (sucursal && sucursal.datos_empresa) || {};
    var datosFel = movimiento.datos_fel;

    var datosGen = null;
    if (datosFel && datosFel.datos_generados) {
        datosGen = datosFel.datos_generados;
        if (typeof datosGen === "string") {
            try {
                datosGen = JSON.parse(datosGen.replace(/'/g, '"').replace(/None/g, 'null').replace(/True/g, 'true').replace(/False/g, 'false'));
            } catch(e) { datosGen = null; }
        }
    }

    var respFinanzia = (datosGen && datosGen.response) || {};
    var complementos = respFinanzia.complementos || [];
    var items = respFinanzia.items || [];
    var datosFel = movimiento.datos_fel;

    var doc = createDocument();

    doc.text(centrar(datosEmpresa.nombre_comercial || datosEmpresa.nombre || ""));
    if (sucursal) {
        doc.text(centrar(sucursal.nombre || ""));
        if (sucursal.direccion) {
            var lineasDir = partir(sucursal.direccion);
            for (var di = 0; di < lineasDir.length; di++) {
                doc.text(centrar(lineasDir[di]));
            }
        }
        if (sucursal.telefono) doc.text(centrar("Tel. " + sucursal.telefono));
    }

    doc.text(sep());
    doc.text(centrar("NOTA DE CREDITO"));
    doc.text(centrar("ELECTRONICA"));
    doc.text(sep());

    if (datosFel) {
        doc.text(pad("Serie:", datosFel.serie || ""));
        doc.text(pad("Numero:", datosFel.numero || ""));
    }
    doc.text(pad("Fecha:", fmtFecha(movimiento.creado)));

    doc.text(sep());

    if (complementos.length > 0) {
        var comp = complementos[0];
        doc.text(centrar("DOCUMENTO ORIGEN"));
        doc.text(pad("Serie:", comp.serie || ""));
        doc.text(pad("Numero:", comp.numero_documento || ""));
        doc.text("Autorizacion:");
        doc.text(comp.numero_autorizacion || "");
        doc.text(pad("Motivo:", comp.motivo || ""));
    }

    doc.text(sep());

    doc.text(pad("Nombre:", respFinanzia.nombre_receptor || "---"));
    doc.text(pad("NIT:", respFinanzia.nit_receptor || "CF"));

    doc.text(sep());

    doc.text(pad("ARTICULOS", "SUB TOTAL"));
    for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var desc = item.descripcion || "";
        var cant = item.cantidad || "1";
        var precio = parseFloat(item.precio_unitario || 0).toFixed(2);
        var subtotal = parseFloat(item.monto_total || 0).toFixed(2);

        doc.text(desc);
        doc.text(pad("Q " + precio + " X " + cant, "Q " + subtotal));
    }

    doc.text(sep());
    doc.text(pad("TOTAL NOTA CREDITO", fmt(respFinanzia.monto_total || movimiento.total || 0)));
    doc.text(sep());

    if (datosFel && datosFel.uuid) {
        doc.text(centrar("AUTORIZACION FEL"));
        doc.text(datosFel.uuid);
        if (datosFel.fechaCertificacion) {
            doc.text(centrar("FECHA CERTIFICACION"));
            doc.text(centrar(fmtFecha(datosFel.fechaCertificacion)));
        }
        if (datosGen && datosGen.nit_certificador) {
            doc.text(centrar("CERTIFICADOR"));
            doc.text(centrar("NIT: " + datosGen.nit_certificador));
            doc.text(centrar(datosGen.nombre_certificador || ""));
        }
    }

    doc.text(" ");
    doc.cut();

    return doc;
}


/* ============================================================
   Agregar al final de ThermalPrint/buildReciboVenta.js
   Reutiliza los helpers pad, centrar, sep, fmt, fmtFecha, partir
   que ya están definidos en ese archivo.

   Genera dos documentos distintos según el estado del despacho:
     - Pendiente  -> NOTA DE ENVIO (encabezado: sucursal origen)
     - Completada -> NOTA DE RECEPCION (encabezado: sucursal destino)
   ============================================================ */

/* Arma el bloque de encabezado de una sucursal */
function encabezadoSucursal(doc, sucursal) {
    var suc = sucursal || {};
    var datosEmpresa = suc.datos_empresa || {};

    doc.text(centrar(datosEmpresa.nombre_comercial || datosEmpresa.nombre || " "));
    if (suc.nombre) doc.text(centrar(suc.nombre));
    if (suc.direccion) {
        var lineas = partir(suc.direccion);
        for (var i = 0; i < lineas.length; i++) {
            doc.text(centrar(lineas[i]));
        }
    }
    if (suc.telefono) doc.text(centrar("TEL. " + String(suc.telefono)));
    if (datosEmpresa.nit) doc.text(centrar("NIT. " + String(datosEmpresa.nit)));
}

/* Nombre legible de una línea de detalle */
function nombreDetalle(d) {
    var nombre = (typeof d.producto === "string")
        ? d.producto
        : (d.producto && d.producto.nombre)
            || (d.fraccion && d.fraccion.producto && d.fraccion.producto.nombre)
            || d.nombre
            || " ";
    var fraccion = (d.fraccion && d.fraccion.nombre) ? d.fraccion.nombre : "";
    return fraccion ? String(nombre) + " / " + fraccion : String(nombre);
}

export function createNotaEnvioDoc(opts) {
    var despacho = opts.despacho || {};
    var sucursalOrigen = opts.sucursal_origen || despacho.sucursal || despacho.sucursal_origen || {};
    var sucursalDestino = opts.sucursal_destino || despacho.sucursal_destino || {};
    var mostrarPrecio = opts.conf_mostrar_precio_impresion !== false;

    // Recepción cuando el despacho ya fue recibido
    var esRecepcion = opts.esRecepcion !== undefined
        ? !!opts.esRecepcion
        : !!despacho.recepcionado_por;

    var usuario = despacho.usuario || {};
    var recibidoPor = despacho.recepcionado_por || {};
    var detalles = despacho.detalles || [];

    var doc = createDocument();

    // ---- Encabezado: origen si es envío, destino si es recepción ----
    encabezadoSucursal(doc, esRecepcion ? sucursalDestino : sucursalOrigen);

    doc.text(sep());
    if (esRecepcion) {
        doc.text(centrar("NOTA DE RECEPCION"));
        doc.text(centrar("DE DESPACHO"));
    } else {
        doc.text(centrar("NOTA DE ENVIO"));
    }
    doc.text(sep());

    // ---- Datos del despacho ----
    doc.text(pad("Codigo:", despacho.codigo || " "));
    doc.text(pad("Fecha:", fmtFecha(despacho.creado)));

    doc.text(sep());

    if (esRecepcion) {
        doc.text(pad("Enviado desde:", sucursalOrigen.nombre || " "));
    } else {
        doc.text(pad("Enviado a:", sucursalDestino.nombre || " "));
        if (sucursalDestino.direccion) {
            doc.text("Direccion:");
            var lineasDest = partir(sucursalDestino.direccion);
            for (var dj = 0; dj < lineasDest.length; dj++) {
                doc.text(lineasDest[dj]);
            }
        }
        if (sucursalDestino.telefono) {
            doc.text(pad("Telefono:", String(sucursalDestino.telefono)));
        }
    }

    if (usuario.first_name) doc.text(pad("Generado por:", usuario.first_name));
    if (despacho.responsable_transporte) {
        doc.text("Responsable transporte:");
        var lineasResp = partir(despacho.responsable_transporte);
        for (var dr = 0; dr < lineasResp.length; dr++) {
            doc.text(lineasResp[dr]);
        }
    }
    if (esRecepcion && recibidoPor.first_name) {
        doc.text(pad("Recibido por:", recibidoPor.first_name));
    }

    // ---- Artículos ----
    doc.text(sep());
    doc.text(pad("ARTICULOS", mostrarPrecio ? "SUB TOTAL" : "CANTIDAD"));
    doc.text(sep());

    var totalEnviado = 0;
    var totalRecibido = 0;

    for (var i = 0; i < detalles.length; i++) {
        console.log("DETALLE", detalles[0]);
        var d = detalles[i];
        var cant = Number(d.cantidad) || 0;
        var cantRec = Number(d.cantidad_recibido) || 0;
        totalEnviado += cant;
        totalRecibido += cantRec;

        var lineasDesc = partir(nombreDetalle(d));
        for (var dl = 0; dl < lineasDesc.length; dl++) {
            doc.text(lineasDesc[dl]);
        }

        if (esRecepcion) {
            // En la recepción interesa comparar recibido contra enviado
            doc.text(pad("  Enviado", cant.toFixed(3)));
            doc.text(pad("  Recibido", cantRec.toFixed(3)));
            if (mostrarPrecio) {
                var precioR = Number(d.precio) || Number(d.precio_original) || 0;
                var subtotalR = Number(d.sub_total) || Number(d.subtotal) || (cant * precioR);
                doc.text(pad("  " + fmt(precioR) + " c/u", fmt(subtotalR)));
            }
        } else {
            if (mostrarPrecio) {
                var precio = Number(d.precio) || Number(d.precio_original) || 0;
                var subtotal = Number(d.sub_total) || Number(d.subtotal) || (cant * precio);
                doc.text(pad(fmt(precio) + " X " + cant.toFixed(3), fmt(subtotal)));
            } else {
                doc.text(pad("  Cantidad", cant.toFixed(3)));
            }
        }
    }

    // ---- Totales ----
    doc.text(sep());
    doc.text(pad("TOTAL ENVIADO", totalEnviado.toFixed(3)));
    if (esRecepcion) {
        doc.text(pad("TOTAL RECIBIDO", totalRecibido.toFixed(3)));
        var diferencia = totalEnviado - totalRecibido;
        if (diferencia !== 0) {
            doc.text(pad("DIFERENCIA", diferencia.toFixed(3)));
        }
    }
    if (mostrarPrecio) {
        doc.text(pad("TOTAL", fmt(despacho.precio_monto_total || 0)));
    }

    doc.text(sep());
    doc.text(centrar("ESTE DOCUMENTO"));
    doc.text(centrar("NO ES UNA FACTURA"));

    doc.text(" ");
    doc.text(" ");
    doc.text(centrar("_______________________"));
    doc.text(centrar(esRecepcion ? "Recibi conforme" : "Entregue conforme"));

    doc.text(" ");
    doc.cut();

    return doc;
}

export function buildNotaEnvio(opts) {
    return createNotaEnvioDoc(opts).build();
}

export function buildReciboNCRE(opts) {
    return createReciboNCREDoc(opts).build();
}

export function buildReciboVenta(opts) {
    return createReciboDoc(opts).build();
}

export default buildReciboVenta;